module.exports = __webpack_public_path__ + "img/case-logo-22.ae2747e0.png";